import React from "react";
import { Card, Tabs } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const { TabPane } = Tabs;

const UserStatisticsChart = ({ data = [] }) => {
  const barOptions = {
    chart: {
      type: "column",
      style: {
        fontFamily: "Inter, sans-serif",
      },
    },
    title: {
      text: "Statistiques par Utilisateur",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: data.map((item) => item.name),
      crosshair: true,
    },
    yAxis: [
      {
        title: {
          text: "Nombre",
        },
      },
      {
        title: {
          text: "Montant (MAD)",
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    series: [
      {
        name: "Avertissements",
        data: data.map((item) => item.total_warnings),
        color: "orange",
      },
      {
        name: "Infractions",
        data: data.map((item) => item.total_infractions),
        color: "#ff4d4f",
      },
      {
        name: "Tickets",
        data: data.map((item) => item.achat_tickets_count),
        color: "green",
      },
      {
        name: "Montant Total",
        data: data.map((item) => parseFloat(item.total_revenue)),
        yAxis: 1,
        color: "#1890ff",
      },
    ],
  };

  const pieOptions = {
    chart: {
      type: "pie",
      style: {
        fontFamily: "Inter, sans-serif",
      },

      custom: {}, // Custom object to store the label
      events: {
        render() {
          const chart = this;
          const series = chart.series[0];
          let customLabel = chart.options.chart.custom.label;

          if (!customLabel) {
            // Create the custom label
            customLabel = chart.options.chart.custom.label = chart.renderer
              .label(
                "Total<br/>" +
                  `<strong>${series.data
                    .reduce((sum, point) => sum + point.y, 0)
                    .toFixed(2)} MAD</strong>`
              )
              .css({
                color: "#000",
                textAnchor: "middle",
              })
              .add();
          }

          // Position the label at the center of the pie chart
          const x = series.center[0] + chart.plotLeft;
          const y =
            series.center[1] + chart.plotTop - customLabel.attr("height") / 2;

          customLabel.attr({
            x,
            y,
          });

          // Set font size dynamically based on chart diameter
          customLabel.css({
            fontSize: `${series.center[2] / 12}px`,
          });
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Répartition des Montants par Utilisateur",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    tooltip: {
      pointFormat: "Montant: <b>{point.y:.2f} MAD</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    series: [
      {
        name: "Montant",
        colorByPoint: true,
        innerSize: "75%", // Add this for the donut effect
        data: data.map((item) => ({
          name: item.name,
          y: parseFloat(item.total_revenue),
        })),
      },
    ],
  };

  return (
    <Card className="hover:shadow-lg transition-shadow">
      <Tabs defaultActiveKey="1">
        <TabPane tab="Statistiques par Utilisateur" key="1">
          <HighchartsReact highcharts={Highcharts} options={barOptions} />
        </TabPane>
        <TabPane tab="Répartition des Montants" key="2">
          <HighchartsReact highcharts={Highcharts} options={pieOptions} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default UserStatisticsChart;
